<template>
    <svg class="transcript-background" viewBox="0 0 794 1123" preserveAspectRatio="none" aria-hidden="true" focusable="false">
        <rect width="794" height="1123" fill="#fff" />
        <path :d="`M0 0H794V${headerHeight}L0 ${headerHeight * .88}Z`" :fill="palette.cyan" />
        <path :d="`M0 0H794V${headerHeight * .74}L752 ${headerHeight}L0 ${headerHeight * .62}Z`" :fill="palette.navy" />
        <path :d="`M634 0H794V${headerHeight * .74}L752 ${headerHeight}Z`" :fill="palette.gold" />
        <rect :y="1123 - footerHeight" width="794" :height="footerHeight" :fill="palette.gold" />
        <path :d="`M76 1123L280 ${1123 - footerHeight}H339L450 1123Z`" :fill="palette.navy" />
    </svg>
</template>

<script>
import { CERTIFICATE_PALETTE } from '../common/certificateFrame'

export default {
    name: 'TranscriptBackground',
    props: {
        headerHeight: { type: Number, default: 122 },
        footerHeight: { type: Number, default: 52 },
        palette: { type: Object, default: () => CERTIFICATE_PALETTE }
    }
}
</script>

<style scoped>
.transcript-background {
    position: absolute;
    inset: 0;
    display: block;
    width: 100%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    user-select: none;
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
}
</style>
